export default __webpack_public_path__ + "static/media/POPPINS-LIGHTITALIC.a26229d6.TTF";